import { Typography } from "@material-ui/core";
import { FC, useEffect, useState } from "react";

import { qar } from "../../../utils/generic";
import { firestore } from "../../../init/firebase";
import Loader from "../../../components/Loader";

const SessionPrice: FC<any> = ({ record }) => {
  const [loading, setLoading] = useState(true);
  const [price, setPrice] = useState<number | null>(null);

  useEffect(() => {
    (async function () {
      const snapshot = await firestore.collection("payments").where("snapshotRef", "==", record.ref).get();
      console.log({ snapshot, record: record.ref });
      if (!snapshot.empty) {
        setPrice(snapshot.docs[0].data().data.price);
      }

      setLoading(false);
    })();
  }, []);

  return (
    <Typography style={{ width: 150 }} color="textSecondary">
      <Loader loading={loading}>{price ? qar(price) : "N/A"}</Loader>
    </Typography>
  );
};

export default SessionPrice;
